const setIncome = (val = null) => {
  return {
    type: 'SET_INCOME',
    data: val,
  }
}

export default {
  setIncome,
}
